<template>
  <div class="container-fluid py-4">
    <Loading v-if="loading" />

    <!-- Filtros de Data -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <span class="text-sm font-weight-bold me-3"
                >Filtrar por período:</span
              >
              <button
                class="btn btn-sm mb-0"
                :class="
                  filterType === 'today'
                    ? 'bg-gradient-primary'
                    : 'btn-outline-primary'
                "
                @click="setFilter('today')"
              >
                Hoje
              </button>
              <button
                class="btn btn-sm mb-0"
                :class="
                  filterType === 'yesterday'
                    ? 'bg-gradient-primary'
                    : 'btn-outline-primary'
                "
                @click="setFilter('yesterday')"
              >
                Ontem
              </button>
              <button
                class="btn btn-sm mb-0"
                :class="
                  filterType === 'month'
                    ? 'bg-gradient-primary'
                    : 'btn-outline-primary'
                "
                @click="setFilter('month')"
              >
                Este Mês
              </button>
              <button
                class="btn btn-sm mb-0"
                :class="
                  filterType === 'last_month'
                    ? 'bg-gradient-primary'
                    : 'btn-outline-primary'
                "
                @click="setFilter('last_month')"
              >
                Mês Anterior
              </button>
              <button
                class="btn btn-sm mb-0"
                :class="
                  filterType === 'last_year'
                    ? 'bg-gradient-primary'
                    : 'btn-outline-primary'
                "
                @click="setFilter('last_year')"
              >
                Último Ano
              </button>
              <button
                class="btn btn-sm mb-0"
                :class="
                  filterType === 'custom'
                    ? 'bg-gradient-primary'
                    : 'btn-outline-primary'
                "
                @click="filterType = 'custom'"
              >
                Personalizado
              </button>

              <div
                v-if="filterType === 'custom'"
                class="d-flex align-items-center flex-wrap gap-2"
              >
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="dateStart"
                  style="max-width: 130px"
                />
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="dateEnd"
                  style="max-width: 130px"
                />
                <button
                  class="btn btn-sm btn-success mb-0 text-nowrap"
                  @click="loadDashboardData"
                >
                  Aplicar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cards de Métricas -->
    <div class="row mb-4">
      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-dark shadow-dark text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">people</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Usuários</p>
              <h4 class="mb-0">{{ metrics.total_users }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">campaign</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Campanhas</p>
              <h4 class="mb-0">{{ metrics.total_campaigns }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-success shadow-success text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">monetization_on</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Volume plataforma</p>
              <h4 class="mb-0">
                {{ formatCurrency(metrics.platform_volume || metrics.total_revenue) }}
              </h4>
              <p class="text-xxs text-secondary mb-0 mt-1">
                Rifas {{ formatCurrency(metrics.gmv_sales || 0) }}
                · Taxas {{ formatCurrency(metrics.publication_fees || 0) }}
                · Planos {{ formatCurrency(metrics.plan_revenue || 0) }}
                · Carteira {{ formatCurrency(metrics.wallet_admin_fees || 0) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-info shadow-info text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">account_balance</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Taxa Carteira (10%)</p>
              <h4 class="mb-0">{{ formatCurrency(metrics.beeasy_share) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-warning shadow-warning text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">trending_up</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Ativas</p>
              <h4 class="mb-0">{{ metrics.active_campaigns }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-danger shadow-danger text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">trending_down</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Inativas</p>
              <h4 class="mb-0">{{ metrics.inactive_campaigns }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-success shadow-success text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">payments</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">MRR estimado</p>
              <h4 class="mb-0">{{ formatCurrency(mrrValue) }}</h4>
              <p class="text-xxs text-secondary mb-0 mt-1">
                {{ metrics.plan_mensal_active || 0 }} ×
                {{ formatCurrency(planMonthlyPrice) }}
                <button
                  type="button"
                  class="btn btn-link btn-sm p-0 text-xxs ms-1"
                  @click="editPlanMonthlyPrice"
                  title="Definir valor unitário do plano mensal"
                >
                  editar
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div
              class="icon icon-lg icon-shape bg-gradient-info shadow-info text-center border-radius-xl mt-n4 position-absolute"
            >
              <i class="material-icons opacity-10">workspace_premium</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Planos ativos</p>
              <h4 class="mb-0">
                {{ (metrics.plan_mensal_active || 0) + (metrics.plan_anual_active || 0) + (metrics.plan_vitalicio_active || 0) }}
              </h4>
              <p class="text-xxs text-secondary mb-0 mt-1">
                {{ metrics.plan_mensal_active || 0 }} mensal ·
                {{ metrics.plan_anual_active || 0 }} anual ·
                {{ metrics.plan_vitalicio_active || 0 }} vitalício
                <span v-if="metrics.plan_mensal_expired">
                  · {{ metrics.plan_mensal_expired }} vencido(s)
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos -->
    <div class="row mb-4">
      <div class="col-lg-6 mb-4">
        <div class="card z-index-2">
          <div class="card-header p-3">
            <h6 class="mb-0">Volume ao Longo do Tempo</h6>
            <p class="text-sm mb-0">Rifas + taxas + planos + taxa da carteira</p>
          </div>
          <div class="card-body p-3">
            <DashboardChart
              v-if="revenueChartData"
              :data="revenueChartData"
              type="line"
              :options="revenueChartOptions"
              height="300"
            />
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="card z-index-2">
          <div class="card-header p-3">
            <h6 class="mb-0">Novos Usuários</h6>
            <p class="text-sm mb-0">Cadastros realizados no período</p>
          </div>
          <div class="card-body p-3">
            <DashboardChart
              v-if="usersChartData"
              :data="usersChartData"
              type="line"
              :options="usersChartOptions"
              height="300"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos de Comparação -->
    <div class="row mb-4">
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card shadow-lg border-radius-xl h-100">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">💳 Meios de Pagamento</h6>
            <p class="text-xs text-secondary mt-1">Participantes (Pagos)</p>
          </div>
          <div class="card-body p-3">
            <DashboardChart
              v-if="paymentMethodsChartData"
              :data="paymentMethodsChartData"
              type="doughnut"
              :options="pieOptions"
              height="220"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card shadow-lg border-radius-xl h-100">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">🎰 Origem dos Sorteios</h6>
            <p class="text-xs text-secondary mt-1">Preferência dos criadores</p>
          </div>
          <div class="card-body p-3">
            <DashboardChart
              v-if="campaignDrawersChartData"
              :data="campaignDrawersChartData"
              type="pie"
              :options="pieOptions"
              height="220"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 mb-4">
        <div class="card shadow-lg border-radius-xl h-100">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">⚖️ Status das Campanhas</h6>
            <p class="text-xs text-secondary mt-1">Distribuição geral</p>
          </div>
          <div class="card-body p-3">
            <DashboardChart
              v-if="campaignStatusChartData"
              :data="campaignStatusChartData"
              type="polarArea"
              :options="pieOptions"
              height="220"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- SEÇÃO: Origens de Tráfego & Inteligência de Aquisição / Canais -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card shadow-lg border-radius-xl">
          <!-- Cabeçalho da Seção com Badge e Explicação -->
          <div class="card-header p-3 pb-0">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
              <div>
                <div class="d-flex align-items-center gap-2">
                  <span class="source-main-icon-bubble">
                    <i class="material-icons">ads_click</i>
                  </span>
                  <div>
                    <h5 class="mb-0 font-weight-bolder text-dark">
                      🎯 Inteligência de Origem & Conversão (Tráfego / Canais)
                    </h5>
                    <p class="text-xs text-secondary mb-0">
                      Análise estratégica de onde vêm seus criadores, ativação de campanhas e receita por canal
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-gradient-info text-xxs font-weight-bold">
                  {{ sourcesAnalytics.sources.length }} Canais Identificados
                </span>
                <span class="badge bg-gradient-dark text-xxs font-weight-bold">
                  {{ sourcesAnalytics.total_users }} Cadastros no Período
                </span>
              </div>
            </div>
          </div>

          <div class="card-body p-3">
            <!-- 4 Mini Cards de Resumo Estratégico -->
            <div class="row g-3 mb-4">
              <!-- Card 1: Principal Canal em Cadastros -->
              <div class="col-xl-3 col-sm-6">
                <div class="source-kpi-card bg-gradient-light border-radius-lg p-3">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <span class="text-xxs font-weight-bolder text-uppercase text-secondary">
                      Mais Cadastros
                    </span>
                    <i class="material-icons text-info text-sm">people</i>
                  </div>
                  <h5 class="font-weight-bolder text-dark mb-0">
                    {{ topSourceByUsers ? topSourceByUsers.label : 'Nenhum' }}
                  </h5>
                  <p class="text-xxs text-secondary mb-0 mt-1" v-if="topSourceByUsers">
                    <strong>{{ topSourceByUsers.total_users }}</strong> cadastros ({{ topSourceByUsers.users_percent?.toFixed(1) }}%)
                  </p>
                </div>
              </div>

              <!-- Card 2: Canal Mais Lucrativo (Taxas + Planos) -->
              <div class="col-xl-3 col-sm-6">
                <div class="source-kpi-card bg-gradient-light border-radius-lg p-3">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <span class="text-xxs font-weight-bolder text-uppercase text-secondary">
                      Maior Receita (Taxas/Planos)
                    </span>
                    <i class="material-icons text-success text-sm">payments</i>
                  </div>
                  <h5 class="font-weight-bolder text-dark mb-0">
                    {{ topSourceByRevenue ? topSourceByRevenue.label : 'Nenhum' }}
                  </h5>
                  <p class="text-xxs text-secondary mb-0 mt-1" v-if="topSourceByRevenue">
                    <strong>{{ formatCurrency(topSourceByRevenue.total_platform_revenue) }}</strong> gerados
                  </p>
                </div>
              </div>

              <!-- Card 3: Melhor Taxa de Ativação / Conversão -->
              <div class="col-xl-3 col-sm-6">
                <div class="source-kpi-card bg-gradient-light border-radius-lg p-3">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <span class="text-xxs font-weight-bolder text-uppercase text-secondary">
                      Melhor Ativação
                    </span>
                    <i class="material-icons text-warning text-sm">trending_up</i>
                  </div>
                  <h5 class="font-weight-bolder text-dark mb-0">
                    {{ topSourceByConversion ? topSourceByConversion.label : 'Nenhum' }}
                  </h5>
                  <p class="text-xxs text-secondary mb-0 mt-1" v-if="topSourceByConversion">
                    <strong>{{ topSourceByConversion.conversion_rate?.toFixed(1) }}%</strong> criaram rifas
                  </p>
                </div>
              </div>

              <!-- Card 4: Volume Total Movimentado (GMV) -->
              <div class="col-xl-3 col-sm-6">
                <div class="source-kpi-card bg-gradient-light border-radius-lg p-3">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <span class="text-xxs font-weight-bolder text-uppercase text-secondary">
                      Total Vendido (GMV Rifas)
                    </span>
                    <i class="material-icons text-primary text-sm">monetization_on</i>
                  </div>
                  <h5 class="font-weight-bolder text-dark mb-0">
                    {{ formatCurrency(sourcesAnalytics.total_gmv || 0) }}
                  </h5>
                  <p class="text-xxs text-secondary mb-0 mt-1">
                    Rifas criadas pelos usuários do período
                  </p>
                </div>
              </div>
            </div>

            <!-- Gráficos de Canais lado a lado -->
            <div class="row mb-4">
              <div class="col-lg-5 mb-3 mb-lg-0">
                <div class="border border-radius-lg p-3 h-100 bg-white">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h6 class="text-sm font-weight-bold mb-0">👥 Cadastros por Canal</h6>
                    <span class="text-xxs text-secondary">Distribuição %</span>
                  </div>
                  <DashboardChart
                    v-if="sourcesUsersChartData"
                    :data="sourcesUsersChartData"
                    type="doughnut"
                    :options="sourcesDoughnutOptions"
                    height="230"
                  />
                  <div v-else class="text-center py-5 text-xs text-secondary">
                    Sem dados de cadastros no período
                  </div>
                </div>
              </div>

              <div class="col-lg-7">
                <div class="border border-radius-lg p-3 h-100 bg-white">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <h6 class="text-sm font-weight-bold mb-0">💵 Receita Gerada por Canal (Taxas + Planos)</h6>
                    <span class="text-xxs text-secondary">R$ Arrecadados</span>
                  </div>
                  <DashboardChart
                    v-if="sourcesRevenueChartData"
                    :data="sourcesRevenueChartData"
                    type="bar"
                    :options="sourcesBarOptions"
                    height="230"
                  />
                  <div v-else class="text-center py-5 text-xs text-secondary">
                    Sem receita de taxas/planos no período
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabela Comparativa Estratégica Completa -->
            <div class="table-responsive border border-radius-lg bg-white">
              <table class="table align-items-center mb-0">
                <thead class="bg-gray-100">
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3">
                      Origem / Canal
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Cadastros (% Total)
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Campanhas Criadas
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Campanhas Ativas
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Taxa de Ativação
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Taxas & Planos (Receita)
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 pe-3">
                      Vendas das Rifas (GMV)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!sourcesAnalytics.sources || sourcesAnalytics.sources.length === 0">
                    <td colspan="7" class="text-center py-4 text-xs text-secondary">
                      Nenhum cadastro com origem registrada no período selecionado.
                    </td>
                  </tr>
                  <tr
                    v-for="s in sourcesAnalytics.sources"
                    :key="s.source"
                    class="hover-bg-light transition-all"
                  >
                    <td class="ps-3 py-2">
                      <div class="d-flex align-items-center">
                        <span
                          class="source-pill-badge me-2"
                          :class="getSourceBadgeMeta(s.source).badgeClass"
                        >
                          <i class="material-icons text-xs me-1">{{ getSourceBadgeMeta(s.source).icon }}</i>
                          {{ s.label }}
                        </span>
                      </div>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs font-weight-bolder text-dark">{{ s.total_users }}</span>
                      <span class="text-xxs text-secondary ms-1">({{ s.users_percent?.toFixed(1) }}%)</span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs font-weight-bold text-dark">{{ s.total_campaigns }}</span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="badge badge-sm bg-gradient-success text-xxs" v-if="s.active_campaigns > 0">
                        {{ s.active_campaigns }} ativas
                      </span>
                      <span class="text-xxs text-secondary" v-else>0</span>
                    </td>
                    <td class="text-center align-middle">
                      <span
                        class="badge badge-sm text-xxs"
                        :class="s.conversion_rate >= 20 ? 'bg-gradient-success' : s.conversion_rate > 0 ? 'bg-gradient-warning' : 'bg-gradient-secondary'"
                      >
                        {{ s.conversion_rate?.toFixed(1) }}%
                      </span>
                    </td>
                    <td class="text-center align-middle">
                      <span class="text-xs font-weight-bolder text-success">
                        {{ formatCurrency(s.total_platform_revenue) }}
                      </span>
                      <span class="text-xxs text-secondary d-block" v-if="s.plan_revenue > 0">
                        ({{ formatCurrency(s.publication_fees) }} taxas + {{ formatCurrency(s.plan_revenue) }} planos)
                      </span>
                    </td>
                    <td class="text-center align-middle pe-3">
                      <span class="text-xs font-weight-bold text-dark">
                        {{ formatCurrency(s.total_gmv) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rankings de Usuários -->
    <div class="row mb-4">
      <!-- Ranking por Campanhas -->
      <div class="col-lg-6 mb-4 mb-lg-0">
        <div class="card shadow-lg border-radius-xl h-100">
          <div class="card-header pb-0 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">🏆 Ranking de Usuários por Campanhas</h6>
              <span class="badge badge-sm bg-gradient-dark"
                >{{ topUsers.length }} Destaques</span
              >
            </div>
          </div>
          <div class="card-body p-3">
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Posição
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Usuário
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Campanhas
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(user, index) in paginatedTopUsers"
                    :key="user.user_id"
                    class="ranking-row"
                  >
                    <td class="align-middle">
                      <div class="d-flex align-items-center ps-2">
                        <div
                          v-if="
                            (pagination.topUsers.current - 1) *
                              pagination.topUsers.limit +
                              index ===
                            0
                          "
                          class="medal medal-gold"
                        >
                          🥇
                        </div>
                        <div
                          v-else-if="
                            (pagination.topUsers.current - 1) *
                              pagination.topUsers.limit +
                              index ===
                            1
                          "
                          class="medal medal-silver"
                        >
                          🥈
                        </div>
                        <div
                          v-else-if="
                            (pagination.topUsers.current - 1) *
                              pagination.topUsers.limit +
                              index ===
                            2
                          "
                          class="medal medal-bronze"
                        >
                          🥉
                        </div>
                        <span v-else class="text-sm font-weight-bold grey-rank"
                          >{{
                            (pagination.topUsers.current - 1) *
                              pagination.topUsers.limit +
                            index +
                            1
                          }}º</span
                        >
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1 align-items-center">
                        <div
                          class="avatar avatar-sm me-3 bg-gradient-primary rounded-circle shadow-sm d-flex align-items-center justify-content-center text-white font-weight-bold"
                        >
                          {{ getInitials(user.full_name) }}
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ user.full_name }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.email }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-pill bg-light text-dark font-weight-bold px-3"
                      >
                        {{ user.campaigns_count }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação Ranking -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-2 pb-2"
              v-if="totalPages.topUsers > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.topUsers.current }} de
                {{ totalPages.topUsers }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.topUsers.current === 1"
                  @click="movePage('topUsers', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="
                    pagination.topUsers.current === totalPages.topUsers
                  "
                  @click="movePage('topUsers', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ranking de Usuários por Arrecadação -->
      <div class="col-lg-6">
        <div class="card shadow-lg border-radius-xl h-100">
          <div class="card-header pb-0 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">💰 Ranking de Usuários por Arrecadação</h6>
              <div class="d-flex gap-2">
                <span class="badge badge-sm bg-gradient-success"
                  >{{ formatCurrency(topUsersRevenueSum) }} Total</span
                >
                <span class="badge badge-sm bg-gradient-dark"
                  >{{ topUsersRevenueTotal }} Usuários</span
                >
              </div>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Posição
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Usuário
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Total Arrecadado
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="user in paginatedTopUsersRevenue"
                    :key="user.whatsapp"
                    class="ranking-row"
                  >
                    <td class="align-middle">
                      <div class="d-flex align-items-center ps-2">
                        <div v-if="user.posicao === 1" class="medal medal-gold">
                          🥇
                        </div>
                        <div
                          v-else-if="user.posicao === 2"
                          class="medal medal-silver"
                        >
                          🥈
                        </div>
                        <div
                          v-else-if="user.posicao === 3"
                          class="medal medal-bronze"
                        >
                          🥉
                        </div>
                        <span v-else class="text-sm font-weight-bold grey-rank"
                          >{{ user.posicao }}º</span
                        >
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1 align-items-center">
                        <div
                          class="avatar avatar-sm me-3 bg-gradient-success rounded-circle shadow-sm d-flex align-items-center justify-content-center text-white font-weight-bold"
                        >
                          {{ getInitials(user.nome) }}
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ user.nome }}</h6>
                          <a
                            :href="
                              'https://wa.me/' +
                              user.whatsapp.replace(/\D/g, '')
                            "
                            target="_blank"
                            class="text-xxs text-success font-weight-bold"
                          >
                            <i class="fab fa-whatsapp me-1"></i>
                            {{ user.whatsapp }}
                          </a>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-sm font-weight-bold text-dark">
                        {{ formatCurrency(user.total_arrecadado) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação Ranking Arrecadação -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-2 pb-2"
              v-if="totalPages.topUsersRevenue > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.topUsersRevenue.current }} de
                {{ totalPages.topUsersRevenue }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-success btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.topUsersRevenue.current === 1"
                  @click="movePage('topUsersRevenue', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-success btn-sm mb-0 px-3 py-1"
                  :disabled="
                    pagination.topUsersRevenue.current ===
                    totalPages.topUsersRevenue
                  "
                  @click="movePage('topUsersRevenue', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Top Campanhas e Últimas Campanhas -->
    <div class="row mb-4">
      <div class="col-lg-6 mb-4">
        <div class="card h-100 shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">🔥 Campanhas com Mais Participantes</h6>
          </div>
          <div class="card-body p-3">
            <div
              v-for="(camp, index) in paginatedTopCampaigns"
              :key="camp.id"
              class="d-flex align-items-center mb-3 p-2 border-radius-lg bg-gray-100 hover-shadow transition-all"
            >
              <div class="position-relative">
                <img
                  :src="getCampaignImage(camp)"
                  class="avatar avatar-md border-radius-lg shadow-sm bg-white"
                  alt="raffle"
                />
                <span
                  class="badge badge-circle bg-dark position-absolute top-0 start-0 translate-middle border border-white"
                  style="font-size: 0.6rem"
                  >{{
                    (pagination.topCampaigns.current - 1) *
                      pagination.topCampaigns.limit +
                    index +
                    1
                  }}</span
                >
              </div>
              <div
                class="d-flex flex-column ms-3 flex-grow-1"
                style="min-width: 0"
              >
                <h6
                  class="mb-0 text-sm font-weight-bold"
                  :class="{
                    'text-truncate-2': !expandedCampaigns.includes(camp.id),
                  }"
                >
                  {{ camp.name }}
                </h6>
                <a
                  v-if="camp.name.length > 50"
                  href="javascript:;"
                  @click="toggleExpand(camp.id)"
                  class="text-xxs text-primary font-weight-bold"
                >
                  {{
                    expandedCampaigns.includes(camp.id)
                      ? "Ver menos"
                      : "Ver mais"
                  }}
                </a>
                <p class="text-xs text-secondary mb-0 mt-1">
                  <span class="text-xxs font-weight-bold text-dark me-1"
                    >#{{ camp.id }}</span
                  >
                  <i class="material-icons text-xxs align-middle">person</i>
                  {{ camp.creator_name }}
                </p>
              </div>
              <div class="text-end ms-2">
                <span
                  class="badge badge-sm bg-gradient-success rounded-pill px-3"
                >
                  {{ camp.participants_count }} particip.
                </span>
                <p class="text-xxs text-secondary mb-0 mt-1 d-none d-sm-block">
                  Total aprovados
                </p>
              </div>
            </div>

            <!-- Paginação Top Campanhas -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-2 pb-2"
              v-if="totalPages.topCampaigns > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.topCampaigns.current }} de
                {{ totalPages.topCampaigns }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.topCampaigns.current === 1"
                  @click="movePage('topCampaigns', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="
                    pagination.topCampaigns.current === totalPages.topCampaigns
                  "
                  @click="movePage('topCampaigns', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>

            <div v-if="topCampaigns.length === 0" class="text-center py-4">
              <i class="material-icons text-secondary opacity-5 fs-1"
                >sentiment_dissatisfied</i
              >
              <p class="text-sm text-secondary mt-2">
                Nenhuma campanha com participantes no período
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="card h-100 shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">🆕 Últimas Campanhas Cadastradas</h6>
          </div>
          <div class="card-body p-3">
            <div
              v-for="camp in paginatedLatestCampaigns"
              :key="camp.id"
              class="d-flex align-items-center mb-3 p-2 border-radius-lg border-start border-4 border-primary bg-gray-50 hover-shadow transition-all"
            >
              <img
                :src="getCampaignImage(camp)"
                class="avatar avatar-md border-radius-lg shadow-sm bg-white"
                alt="raffle"
              />
              <div
                class="d-flex flex-column ms-3 flex-grow-1"
                style="min-width: 0"
              >
                <h6
                  class="mb-0 text-sm font-weight-bold"
                  :class="{
                    'text-truncate-2': !expandedCampaigns.includes(camp.id),
                  }"
                >
                  {{ camp.name }}
                </h6>
                <a
                  v-if="camp.name.length > 50"
                  href="javascript:;"
                  @click="toggleExpand(camp.id)"
                  class="text-xxs text-primary font-weight-bold"
                >
                  {{
                    expandedCampaigns.includes(camp.id)
                      ? "Ver menos"
                      : "Ver mais"
                  }}
                </a>
                <p class="text-xs text-secondary mb-0 mt-1">
                  <span class="text-xxs font-weight-bold text-dark me-1"
                    >#{{ camp.id }}</span
                  >
                  Criado em: {{ formatDate(camp.created_at) }}
                </p>
              </div>
              <div class="text-end ms-2">
                <span class="text-xs text-dark font-weight-bold d-block">{{
                  camp.creator_name
                }}</span>
                <span
                  v-if="camp.creator_source"
                  class="source-pill-badge source-pill-badge--sm d-inline-flex align-items-center mt-1"
                  :class="getSourceBadgeMeta(camp.creator_source).badgeClass"
                  :title="`Origem do criador: ${getSourceBadgeMeta(camp.creator_source).label}`"
                >
                  <i class="material-icons text-xxs me-1">{{ getSourceBadgeMeta(camp.creator_source).icon }}</i>
                  {{ getSourceBadgeMeta(camp.creator_source).label }}
                </span>
                <p class="text-xxs text-secondary mb-0 d-none d-sm-block" v-else>
                  Organizador
                </p>
              </div>
            </div>

            <!-- Paginação Últimas Campanhas -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-2 pb-2"
              v-if="totalPages.latestCampaigns > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.latestCampaigns.current }} de
                {{ totalPages.latestCampaigns }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.latestCampaigns.current === 1"
                  @click="movePage('latestCampaigns', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="
                    pagination.latestCampaigns.current ===
                    totalPages.latestCampaigns
                  "
                  @click="movePage('latestCampaigns', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>

            <div v-if="latestCampaigns.length === 0" class="text-center py-4">
              <i class="material-icons text-secondary opacity-5 fs-1"
                >event_busy</i
              >
              <p class="text-sm text-secondary mt-2">
                Nenhuma campanha cadastrada no período
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Novas Listas Master -->
    <div class="row">
      <!-- Atividade Recente -->
      <div class="col-lg-6 mb-4">
        <div class="card shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">🚀 Atividade Recente no Período</h6>
          </div>
          <div class="card-body p-3">
            <div class="table-responsive p-0" v-if="recentActivity.length > 0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Campanha
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Vendas
                    </th>
                    <th
                      class="text-middle text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Progresso
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="r in paginatedRecentActivity"
                    :key="r.id"
                    class="hover-bg-light transition-all"
                  >
                    <td>
                      <div class="d-flex px-2 py-1 align-items-center">
                        <div>
                          <img
                            :src="getCampaignImage(r)"
                            class="avatar avatar-sm me-3 border-radius-lg shadow-sm"
                            alt="img"
                          />
                        </div>
                        <div
                          class="d-flex flex-column justify-content-center"
                          style="max-width: 200px"
                        >
                          <h6 class="mb-0 text-xs text-truncate">
                            {{ r.name }}
                          </h6>
                          <div class="d-flex align-items-center gap-1 mt-1">
                            <p class="text-xxs text-secondary mb-0 text-truncate">
                              #{{ r.id }} - {{ r.creator_name }}
                            </p>
                            <span
                              v-if="r.creator_source"
                              class="source-pill-badge source-pill-badge--xs d-inline-flex align-items-center"
                              :class="getSourceBadgeMeta(r.creator_source).badgeClass"
                            >
                              {{ getSourceBadgeMeta(r.creator_source).label }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bolder text-dark">{{
                        r.qnt_quotas - r.remaining_quotas
                      }}</span>
                      <span class="text-xxs text-secondary d-block">cotas</span>
                    </td>
                    <td class="align-middle text-center" style="width: 150px">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        <span class="text-xxs font-weight-bold me-2"
                          >{{ getSalesProgress(r) }}%</span
                        >
                        <div class="progress flex-grow-1" style="height: 4px">
                          <div
                            class="progress-bar bg-gradient-success"
                            role="progressbar"
                            :style="{ width: getSalesProgress(r) + '%' }"
                          ></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação Atividade Recente -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-3 pb-3"
              v-if="totalPages.recentActivity > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.recentActivity.current }} de
                {{ totalPages.recentActivity }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.recentActivity.current === 1"
                  @click="movePage('recentActivity', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="
                    pagination.recentActivity.current ===
                    totalPages.recentActivity
                  "
                  @click="movePage('recentActivity', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>

            <div v-else class="text-center py-4">
              <i class="material-icons text-secondary opacity-3 fs-1"
                >local_fire_department</i
              >
              <p class="text-xs text-secondary mt-2">
                Nenhuma atividade recente nos últimos 3 dias
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Finalizadas -->
      <div class="col-lg-6 mb-4">
        <div class="card shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">🏁 Campanhas Finalizadas</h6>
              <div
                class="bg-gradient-success p-2 px-3 border-radius-lg shadow-sm"
              >
                <p class="text-xxs text-white mb-0 text-uppercase opacity-7">
                  Arrecadação Total Usuários
                </p>
                <h6 class="text-white mb-0">
                  {{ formatCurrency(globalTotalCollected) }}
                </h6>
              </div>
            </div>
          </div>
          <div class="card-body p-3">
            <div
              class="table-responsive p-0"
              v-if="finishedCampaigns.length > 0"
            >
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Campanha
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 cursor-pointer"
                      @click="toggleFinishedSort('fee')"
                    >
                      Ganhos (Nós)
                      <i class="material-icons text-xxs ms-1">{{
                        getSortIcon("fee")
                      }}</i>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 cursor-pointer"
                      @click="toggleFinishedSort('collected')"
                    >
                      Arrecadação (Usuário)
                      <i class="material-icons text-xxs ms-1">{{
                        getSortIcon("collected")
                      }}</i>
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="r in paginatedFinishedCampaigns"
                    :key="r.id"
                    class="hover-bg-light transition-all"
                  >
                    <td>
                      <div class="d-flex px-2 py-1 align-items-center">
                        <div>
                          <img
                            :src="getCampaignImage(r)"
                            class="avatar avatar-sm me-3 border-radius-lg shadow-sm"
                            alt="img"
                          />
                        </div>
                        <div
                          class="d-flex flex-column justify-content-center"
                          style="max-width: 200px"
                        >
                          <h6 class="mb-0 text-xs text-truncate">
                            {{ r.name }}
                          </h6>
                          <p class="text-xxs text-secondary mb-0">
                            #{{ r.id }} - {{ r.creator_name }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bolder text-info">{{
                        formatCurrency(r.publication_fee)
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bolder text-success">{{
                        formatCurrency(r.total_collected)
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-secondary"
                        >FINALIZADA</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação Finalizadas -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-3 pb-3"
              v-if="totalPages.finishedCampaigns > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.finishedCampaigns.current }} de
                {{ totalPages.finishedCampaigns }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.finishedCampaigns.current === 1"
                  @click="movePage('finishedCampaigns', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                  :disabled="
                    pagination.finishedCampaigns.current ===
                    totalPages.finishedCampaigns
                  "
                  @click="movePage('finishedCampaigns', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>

            <div v-else class="text-center py-4">
              <i class="material-icons text-secondary opacity-3 fs-1">flag</i>
              <p class="text-xs text-secondary mt-2">
                Nenhuma campanha finalizada encontrada
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Elegíveis a placa física -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <h6 class="mb-0">Placas — elegíveis a envio</h6>
                <span class="text-xs text-secondary"
                  >Clientes com faturamento vitalício a partir de R$ 10.000</span
                >
              </div>
              <span class="badge badge-sm bg-gradient-success mb-0"
                >{{ plaqueEligible.length }} usuários</span
              >
            </div>
          </div>
          <div class="card-body p-3">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Usuário
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                      Contato
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Faturamento
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Placa
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="u in paginatedPlaqueEligible"
                    :key="'plaque-' + u.id"
                    class="ranking-row"
                  >
                    <td>
                      <p class="text-xs font-weight-bold mb-0 px-2">{{ u.full_name }}</p>
                      <p class="text-xxs text-secondary mb-0 px-2">#{{ u.id }}</p>
                    </td>
                    <td>
                      <p class="text-xxs mb-0" v-if="u.phone">{{ u.phone }}</p>
                      <p class="text-xxs text-secondary mb-0" v-if="u.email">{{ u.email }}</p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bold">{{
                        formatCurrency(u.lifetime_revenue)
                      }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-warning">{{
                        u.highest_tier_label || "—"
                      }}</span>
                    </td>
                    <td class="align-middle text-end">
                      <button
                        type="button"
                        class="btn btn-sm btn-success mb-0"
                        :disabled="!u.phone"
                        @click="contactPlaqueEligible(u)"
                      >
                        WhatsApp
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="d-flex justify-content-between align-items-center mt-3"
              v-if="totalPages.plaqueEligible > 1"
            >
              <span class="text-xs text-secondary">
                Página {{ pagination.plaqueEligible.current }} de
                {{ totalPages.plaqueEligible }}
              </span>
              <div>
                <button
                  class="btn btn-sm btn-outline-secondary mb-0 me-1"
                  :disabled="pagination.plaqueEligible.current === 1"
                  @click="movePage('plaqueEligible', -1)"
                >
                  Anterior
                </button>
                <button
                  class="btn btn-sm btn-outline-secondary mb-0"
                  :disabled="
                    pagination.plaqueEligible.current === totalPages.plaqueEligible
                  "
                  @click="movePage('plaqueEligible', 1)"
                >
                  Próxima
                </button>
              </div>
            </div>
            <div v-if="plaqueEligible.length === 0" class="text-center py-4">
              <p class="text-sm text-secondary mb-0">
                Nenhum cliente elegível a placa no momento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Campanhas Desativadas -->
    <div class="row">
      <div class="col-12">
        <div class="card shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <h6 class="mb-0">⚠️ Campanhas Desativadas / Abandonadas</h6>
                <span class="text-xs text-secondary"
                  >Inativas há mais de 10 dias ou sem participantes</span
                >
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-dark mb-0"
                :disabled="exportingInactiveOwners"
                @click="exportInactiveOwnersCsv"
              >
                {{ exportingInactiveOwners ? "Gerando..." : "Exportar contatos CSV" }}
              </button>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Campanha
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Criador / Contato
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Inativa há
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Última Venda
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody
                  v-for="camp in paginatedInactive"
                  :key="camp.id"
                  class="border-0"
                >
                  <tr class="ranking-row">
                    <td>
                      <div class="d-flex px-2 py-1 align-items-center">
                        <div>
                          <img
                            :src="getCampaignImage(camp)"
                            class="avatar avatar-sm me-3 border-radius-lg shadow-sm"
                            alt="camp"
                          />
                        </div>
                        <div
                          class="d-flex flex-column justify-content-center"
                          style="max-width: 250px"
                        >
                          <h6 class="mb-0 text-sm text-truncate">
                            {{ camp.name }}
                          </h6>
                          <p class="text-xxs text-secondary mb-0">
                            #{{ camp.id }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ camp.creator_name }}
                      </p>
                      <p class="text-xxs text-secondary mb-0" v-if="camp.creator_phone">
                        {{ camp.creator_phone }}
                      </p>
                      <p class="text-xxs text-secondary mb-0" v-if="camp.creator_email">
                        {{ camp.creator_email }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-danger"
                        >{{ camp.days_inactive }} dias</span
                      >
                    </td>
                    <td class="align-middle text-center">
                      <span
                        v-if="camp.last_sale_at"
                        class="text-secondary text-xs font-weight-bold"
                        >{{ formatDate(camp.last_sale_at) }}</span
                      >
                      <span
                        v-else
                        class="text-secondary text-xxs font-weight-bold italic text-uppercase"
                        style="opacity: 0.7"
                      >
                        Nenhuma Venda
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <button
                        class="btn btn-link text-info mb-0 px-2"
                        @click="toggleParticipants(camp.id)"
                        title="Detalhar Participantes"
                      >
                        <i class="material-icons text-lg">list</i>
                      </button>
                      <button
                        class="btn btn-link text-success mb-0 px-2"
                        @click="contactOwner(camp)"
                        title="Contactar via WhatsApp"
                      >
                        <i class="fab fa-whatsapp text-lg"></i>
                      </button>
                      <button
                        class="btn btn-link text-primary mb-0 px-2"
                        @click="openRaffle(camp.slug)"
                        title="Visualizar Campanha"
                      >
                        <i class="material-icons text-lg">visibility</i>
                      </button>
                    </td>
                  </tr>
                  <!-- Detalhes dos Participantes -->
                  <tr v-if="expandedParticipants.includes(camp.id)">
                    <td colspan="5" class="bg-gray-100 border-radius-lg p-3">
                      <div class="px-4 py-2">
                        <h6 class="text-xs font-weight-bold mb-2">
                          👥 Últimos 5 Participantes:
                        </h6>
                        <div
                          v-if="
                            camp.participants && camp.participants.length > 0
                          "
                        >
                          <div
                            v-for="(p, pIdx) in camp.participants"
                            :key="pIdx"
                            class="d-flex justify-content-between align-items-center mb-1 pb-1 border-bottom border-white"
                          >
                            <span class="text-xxs font-weight-bold text-dark">{{
                              p.name
                            }}</span>
                            <span class="text-xxs text-secondary">{{
                              formatDate(p.created_at)
                            }}</span>
                          </div>
                        </div>
                        <div v-else class="text-xxs text-secondary italic">
                          Nenhum participante encontrado para esta campanha.
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginação Inativas -->
              <div
                class="d-flex justify-content-between align-items-center mt-3 px-3 pb-3"
                v-if="totalPages.inactiveCampaigns > 1"
              >
                <span class="text-xxs text-secondary font-weight-bold">
                  Página {{ pagination.inactiveCampaigns.current }} de
                  {{ totalPages.inactiveCampaigns }}
                </span>
                <div class="d-flex gap-2">
                  <button
                    class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                    :disabled="pagination.inactiveCampaigns.current === 1"
                    @click="movePage('inactiveCampaigns', -1)"
                  >
                    <i class="material-icons text-sm">chevron_left</i>
                  </button>
                  <button
                    class="btn btn-outline-primary btn-sm mb-0 px-3 py-1"
                    :disabled="
                      pagination.inactiveCampaigns.current ===
                      totalPages.inactiveCampaigns
                    "
                    @click="movePage('inactiveCampaigns', 1)"
                  >
                    <i class="material-icons text-sm">chevron_right</i>
                  </button>
                </div>
              </div>

              <div
                v-if="inactiveCampaigns.length === 0"
                class="text-center py-5 w-100"
              >
                <div class="bg-light d-inline-block p-4 rounded-circle mb-3">
                  <i class="material-icons text-success fs-1">check_circle</i>
                </div>
                <h6 class="text-secondary">Ótimas notícias!</h6>
                <p class="text-sm text-secondary">
                  Não há campanhas abandonadas registradas no momento.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Novos Cards de Usuários -->
    <div class="row mt-4">
      <!-- Últimos Usuários Cadastrados -->
      <div class="col-lg-6 mb-4">
        <div class="card h-100 shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">👤 Últimos Usuários Cadastrados</h6>
          </div>
          <div class="card-body p-3">
            <div
              v-for="user in paginatedLatestUsers"
              :key="user.id"
              class="d-flex align-items-center mb-3 p-2 border-radius-lg bg-gray-50 hover-shadow transition-all"
            >
              <div
                class="avatar avatar-md me-3 bg-gradient-info rounded-circle shadow-sm d-flex align-items-center justify-content-center text-white font-weight-bold"
              >
                {{ getInitials(user.full_name) }}
              </div>
              <div class="d-flex flex-column ms-1 flex-grow-1">
                <h6 class="mb-0 text-sm font-weight-bold">{{ user.full_name }}</h6>
                <p class="text-xs text-secondary mb-0 mt-1">
                  <i class="material-icons text-xxs align-middle">email</i> {{ user.email }}
                </p>
                <p class="text-xs text-secondary mb-0" v-if="user.phone">
                  <i class="fab fa-whatsapp text-xxs align-middle text-success"></i> {{ user.phone }}
                </p>
              </div>
              <div class="text-end ms-2">
                <span class="text-xs text-dark font-weight-bold d-block">{{ formatDate(user.created_at) }}</span>
                <span
                  v-if="user.signup_source"
                  class="source-pill-badge source-pill-badge--sm d-inline-flex align-items-center mt-1"
                  :class="getSourceBadgeMeta(user.signup_source).badgeClass"
                  :title="`Origem: ${getSourceBadgeMeta(user.signup_source).label}`"
                >
                  <i class="material-icons text-xxs me-1">{{ getSourceBadgeMeta(user.signup_source).icon }}</i>
                  {{ getSourceBadgeMeta(user.signup_source).label }}
                </span>
                <span class="badge badge-sm bg-gradient-light text-dark mt-1" v-else>ID: {{ user.id }}</span>
              </div>
            </div>

            <!-- Paginação Latest Users -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-2 pb-2"
              v-if="totalPages.latestUsers > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.latestUsers.current }} de {{ totalPages.latestUsers }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-info btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.latestUsers.current === 1"
                  @click="movePage('latestUsers', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-info btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.latestUsers.current === totalPages.latestUsers"
                  @click="movePage('latestUsers', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>

            <div v-if="latestUsers.length === 0" class="text-center py-4">
              <i class="material-icons text-secondary opacity-5 fs-1">person_off</i>
              <p class="text-sm text-secondary mt-2">Nenhum usuário cadastrado no período</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Usuários Inativos -->
      <div class="col-lg-6 mb-4">
        <div class="card h-100 shadow-lg border-radius-xl">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">💤 Usuários Inativos</h6>
            <span class="text-xs text-secondary">Sem campanhas ou sem vendas aprovadas há mais de 7 dias</span>
          </div>
          <div class="card-body p-3">
            <div
              v-for="user in paginatedInactiveUsersList"
              :key="user.id"
              class="d-flex align-items-center mb-3 p-2 border-radius-lg border-start border-4 border-warning bg-gray-50 hover-shadow transition-all"
            >
              <div
                class="avatar avatar-md me-3 bg-gradient-warning rounded-circle shadow-sm d-flex align-items-center justify-content-center text-white font-weight-bold"
              >
                {{ getInitials(user.full_name) }}
              </div>
              <div class="d-flex flex-column ms-1 flex-grow-1">
                <h6 class="mb-0 text-sm font-weight-bold">{{ user.full_name }}</h6>
                <p class="text-xs text-secondary mb-0 mt-1">
                  <strong>{{ user.total_campaigns }}</strong> campanhas criadas
                </p>
                <p class="text-xs text-secondary mb-0" v-if="user.last_sale_at">
                  Última venda: {{ formatDate(user.last_sale_at) }}
                </p>
                <p class="text-xs text-secondary mb-0 italic" v-else>
                  Nenhuma venda aprovada
                </p>
              </div>
              <div class="text-end ms-2 d-flex flex-column align-items-end">
                <span class="badge badge-sm bg-gradient-danger mb-2">{{ user.days_inactive }} dias parado</span>
                <button class="btn btn-link text-success p-0 m-0" @click="contactInactiveUser(user)" title="Contactar via WhatsApp">
                  <i class="fab fa-whatsapp text-lg"></i> Contactar
                </button>
              </div>
            </div>

            <!-- Paginação Inactive Users -->
            <div
              class="d-flex justify-content-between align-items-center mt-3 px-2 pb-2"
              v-if="totalPages.inactiveUsersList > 1"
            >
              <span class="text-xxs text-secondary font-weight-bold">
                Página {{ pagination.inactiveUsersList.current }} de {{ totalPages.inactiveUsersList }}
              </span>
              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-warning btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.inactiveUsersList.current === 1"
                  @click="movePage('inactiveUsersList', -1)"
                >
                  <i class="material-icons text-sm">chevron_left</i>
                </button>
                <button
                  class="btn btn-outline-warning btn-sm mb-0 px-3 py-1"
                  :disabled="pagination.inactiveUsersList.current === totalPages.inactiveUsersList"
                  @click="movePage('inactiveUsersList', 1)"
                >
                  <i class="material-icons text-sm">chevron_right</i>
                </button>
              </div>
            </div>

            <div v-if="inactiveUsersList.length === 0" class="text-center py-4">
              <div class="bg-light d-inline-block p-4 rounded-circle mb-3">
                <i class="material-icons text-success fs-1">check_circle</i>
              </div>
              <p class="text-sm text-secondary mt-2">Todos os usuários estão ativos!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import DashboardHttp from "@/http/DashboardHttp.js";
import DashboardChart from "./DashboardChart.vue";
import { buildCampaignPublicUrl } from "@/store/config.js";
import { buildAdminParabensPlacaWhatsAppUrl } from "@/constants/premiacoesTiers.js";

export default {
  name: "Dashboard",
  components: {
    Loading,
    DashboardChart,
  },
  data() {
    return {
      loading: false,
      exportingInactiveOwners: false,
      filterType: "month",
      dateStart: this.getFirstDayOfMonth(),
      dateEnd: this.getLastDayOfMonth(),
      metrics: {
        total_users: 0,
        total_campaigns: 0,
        total_revenue: 0,
        platform_volume: 0,
        gmv_sales: 0,
        publication_fees: 0,
        plan_revenue: 0,
        wallet_admin_fees: 0,
        beeasy_share: 0,
        active_campaigns: 0,
        inactive_campaigns: 0,
        plan_mensal_active: 0,
        plan_anual_active: 0,
        plan_vitalicio_active: 0,
        plan_mensal_expired: 0,
      },
      planMonthlyPrice: Number(localStorage.getItem("rifa365_plan_monthly_price")) || 97,
      topUsers: [],
      topUsersRevenue: [],
      topUsersRevenueTotal: 0,
      topUsersRevenueSum: 0,
      topCampaigns: [],
      latestCampaigns: [],
      inactiveCampaigns: [],
      plaqueEligible: [],
      expandedCampaigns: [],
      expandedParticipants: [],
      latestUsers: [],
      inactiveUsersList: [],
      revenueChartData: null,
      usersChartData: null,
      paymentMethodsChartData: null,
      campaignDrawersChartData: null,
      campaignStatusChartData: null,
      sourcesAnalytics: {
        sources: [],
        total_users: 0,
        total_revenue: 0,
        total_gmv: 0,
        chart_labels: [],
        chart_users: [],
        chart_revenue: [],
      },
      sourcesUsersChartData: null,
      sourcesRevenueChartData: null,
      sourcesDoughnutOptions: {
        plugins: {
          legend: {
            position: "bottom",
            labels: { boxWidth: 12, font: { size: 10 } },
          },
        },
      },
      sourcesBarOptions: {
        plugins: {
          legend: { display: false },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => "R$ " + value.toFixed(0),
            },
          },
        },
      },
      revenueChartOptions: {
        plugins: {
          legend: { display: false },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => "R$ " + value.toFixed(2),
            },
          },
        },
      },
      usersChartOptions: {
        plugins: {
          legend: { display: false },
        },
        scales: {
          y: { beginAtZero: true },
        },
      },
      pieOptions: {
        plugins: {
          legend: {
            position: "bottom",
            labels: { boxWidth: 12, font: { size: 10 } },
          },
        },
      },
      recentActivity: [],
      finishedCampaigns: [],
      globalTotalCollected: 0,
      finishedSort: {
        column: "updated_at",
        order: "DESC",
      },
      // Paginação
      pagination: {
        topUsers: { current: 1, limit: 10 },
        topUsersRevenue: { current: 1, limit: 10 },
        topCampaigns: { current: 1, limit: 10 },
        latestCampaigns: { current: 1, limit: 10 },
        recentActivity: { current: 1, limit: 10 },
        finishedCampaigns: { current: 1, limit: 10 },
        inactiveCampaigns: { current: 1, limit: 10 },
        latestUsers: { current: 1, limit: 10 },
        inactiveUsersList: { current: 1, limit: 10 },
        plaqueEligible: { current: 1, limit: 10 },
      },
      user: null,
      isUnmounted: false,
    };
  },
  async mounted() {
    this.user = this.$store.getters.user;
    if (!this.user || this.user.role !== "ADMIN") {
      return;
    }
    await this.loadDashboardData();
  },
  beforeUnmount() {
    this.isUnmounted = true;
  },
  computed: {
    mrrValue() {
      return (this.metrics.plan_mensal_active || 0) * (this.planMonthlyPrice || 0);
    },
    topSourceByUsers() {
      const list = this.sourcesAnalytics?.sources || [];
      if (!list.length) return null;
      return [...list].sort((a, b) => b.total_users - a.total_users)[0];
    },
    topSourceByRevenue() {
      const list = this.sourcesAnalytics?.sources || [];
      if (!list.length) return null;
      return [...list].sort((a, b) => b.total_platform_revenue - a.total_platform_revenue)[0];
    },
    topSourceByConversion() {
      const list = this.sourcesAnalytics?.sources || [];
      if (!list.length) return null;
      return [...list].sort((a, b) => b.conversion_rate - a.conversion_rate)[0];
    },
    paginatedTopUsers() {
      const p = this.pagination.topUsers;
      return this.topUsers.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedTopUsersRevenue() {
      // Esse vem do backend já paginado
      return this.topUsersRevenue;
    },
    paginatedTopCampaigns() {
      const p = this.pagination.topCampaigns;
      return this.topCampaigns.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedLatestCampaigns() {
      const p = this.pagination.latestCampaigns;
      return this.latestCampaigns.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedRecentActivity() {
      const p = this.pagination.recentActivity;
      return this.recentActivity.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedFinishedCampaigns() {
      const p = this.pagination.finishedCampaigns;
      return this.finishedCampaigns.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedInactive() {
      const p = this.pagination.inactiveCampaigns;
      return this.inactiveCampaigns.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedLatestUsers() {
      const p = this.pagination.latestUsers;
      return this.latestUsers.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedInactiveUsersList() {
      const p = this.pagination.inactiveUsersList;
      return this.inactiveUsersList.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    paginatedPlaqueEligible() {
      const p = this.pagination.plaqueEligible;
      return this.plaqueEligible.slice(
        (p.current - 1) * p.limit,
        p.current * p.limit
      );
    },
    // Atalhos para total de páginas
    totalPages() {
      return {
        topUsers: Math.ceil(
          this.topUsers.length / this.pagination.topUsers.limit
        ),
        topUsersRevenue: Math.ceil(
          this.topUsersRevenueTotal / this.pagination.topUsersRevenue.limit
        ),
        topCampaigns: Math.ceil(
          this.topCampaigns.length / this.pagination.topCampaigns.limit
        ),
        recentActivity: Math.ceil(
          this.recentActivity.length / this.pagination.recentActivity.limit
        ),
        finishedCampaigns: Math.ceil(
          this.finishedCampaigns.length /
            this.pagination.finishedCampaigns.limit
        ),
        latestCampaigns: Math.ceil(
          this.latestCampaigns.length / this.pagination.latestCampaigns.limit
        ),
        inactiveCampaigns: Math.ceil(
          this.inactiveCampaigns.length /
            this.pagination.inactiveCampaigns.limit
        ),
        latestUsers: Math.ceil(
          this.latestUsers.length / this.pagination.latestUsers.limit
        ),
        inactiveUsersList: Math.ceil(
          this.inactiveUsersList.length / this.pagination.inactiveUsersList.limit
        ),
        plaqueEligible: Math.ceil(
          this.plaqueEligible.length / this.pagination.plaqueEligible.limit
        ),
      };
    },
  },
  methods: {
    contactPlaqueEligible(user) {
      const url = buildAdminParabensPlacaWhatsAppUrl(
        user.phone,
        user.full_name,
        user.highest_tier_label
      );
      if (!url) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Usuário não possui telefone cadastrado",
          life: 3000,
        });
        return;
      }
      window.open(url, "_blank");
    },
    contactOwner(camp) {
      if (!camp.creator_phone) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Usuário não possui telefone cadastrado",
          life: 3000,
        });
        return;
      }

      const phone = camp.creator_phone.replace(/\D/g, "");
      const message = `Olá ${camp.creator_name}, vi que sua campanha "${camp.name}" está inativa há alguns dias. Precisa de alguma ajuda para reativá-la ou finalizar as vendas?`;
      const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    },
    contactInactiveUser(user) {
      if (!user.phone) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Usuário não possui telefone cadastrado",
          life: 3000,
        });
        return;
      }

      const phone = user.phone.replace(/\D/g, "");
      const message = `Olá ${user.full_name}, percebemos que você está inativo no nosso sistema há alguns dias. Precisa de alguma ajuda para criar ou gerenciar suas campanhas?`;
      const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    },
    toggleParticipants(id) {
      if (this.expandedParticipants.includes(id)) {
        this.expandedParticipants = this.expandedParticipants.filter(
          (i) => i !== id
        );
      } else {
        this.expandedParticipants.push(id);
      }
    },
    getFirstDayOfMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      return `${year}-${month}-01`;
    },
    getLastDayOfMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const lastDay = new Date(year, month + 1, 0).getDate();
      const monthStr = String(month + 1).padStart(2, "0");
      return `${year}-${monthStr}-${lastDay}`;
    },
    formatLocalYYYYMMDD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    setFilter(type) {
      this.filterType = type;

      if (type === "today") {
        const today = this.formatLocalYYYYMMDD(new Date());
        this.dateStart = today;
        this.dateEnd = today;
        this.loadDashboardData();
      } else if (type === "month") {
        this.dateStart = this.getFirstDayOfMonth();
        this.dateEnd = this.getLastDayOfMonth();
        this.loadDashboardData();
      } else if (type === "last_month") {
        const now = new Date();
        const firstDayLastMonth = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1
        );
        const lastDayLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);

        this.dateStart = this.formatLocalYYYYMMDD(firstDayLastMonth);
        this.dateEnd = this.formatLocalYYYYMMDD(lastDayLastMonth);
        this.loadDashboardData();
      } else if (type === "yesterday") {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const yesterdayStr = this.formatLocalYYYYMMDD(yesterday);
        this.dateStart = yesterdayStr;
        this.dateEnd = yesterdayStr;
        this.loadDashboardData();
      } else if (type === "last_year") {
        const now = new Date();
        const lastYear = new Date();
        lastYear.setFullYear(now.getFullYear() - 1);
        this.dateStart = this.formatLocalYYYYMMDD(lastYear);
        this.dateEnd = this.formatLocalYYYYMMDD(now);
        this.loadDashboardData();
      }
    },
    toggleFinishedSort(column) {
      if (this.finishedSort.column === column) {
        this.finishedSort.order =
          this.finishedSort.order === "DESC" ? "ASC" : "DESC";
      } else {
        this.finishedSort.column = column;
        this.finishedSort.order = "DESC";
      }
      this.loadDashboardData();
    },
    getSortIcon(column) {
      if (this.finishedSort.column !== column) return "sort";
      return this.finishedSort.order === "DESC"
        ? "arrow_downward"
        : "arrow_upward";
    },
    movePage(list, delta) {
      const p = this.pagination[list];
      const max = this.totalPages[list];
      const next = p.current + delta;

      if (next >= 1 && next <= max) {
        p.current = next;

        // Se for o ranking de arrecadação, precisamos recarregar pois é paginado no server
        if (list === "topUsersRevenue") {
          this.loadTopUsersRevenue();
        }
      }
    },
    async loadTopUsersRevenue() {
      try {
        const params = {
          date_start: this.dateStart,
          date_end: this.dateEnd,
          page: this.pagination.topUsersRevenue.current,
          limit: this.pagination.topUsersRevenue.limit,
        };
        const res = await DashboardHttp.getTopUsersByRevenue(params);
        this.topUsersRevenue = res.data.ranking || [];
        this.topUsersRevenueTotal = res.data.total || 0;
        this.topUsersRevenueSum = res.data.total_revenue || 0;
      } catch (error) {
        console.error("Erro ao carregar ranking de arrecadação:", error);
      }
    },
    async loadDashboardData() {
      if (this.isUnmounted) return;
      this.loading = true;
      const withTimeout = (p, ms = 25000) =>
        Promise.race([
          p,
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("dashboard_timeout")), ms)
          ),
        ]);
      try {
        const params = {
          date_start: this.dateStart,
          date_end: this.dateEnd,
        };

        console.log("📅 Enviando parâmetros:", params);
        console.log("dateStart:", this.dateStart, "dateEnd:", this.dateEnd);

        // Carregar métricas
        try {
          const metricsRes = await withTimeout(DashboardHttp.getMetrics(params));
          this.metrics = metricsRes.data;
        } catch (error) {
          console.error("Erro ao carregar métricas:", error);
        }

        // Carregar rankings e listas (um lento não bloqueia os outros)
        const results = await Promise.allSettled([
          withTimeout(DashboardHttp.getTopUsers(params)),
          withTimeout(DashboardHttp.getTopCampaigns(params)),
          withTimeout(DashboardHttp.getLatestCampaigns(100, params)),
          withTimeout(DashboardHttp.getInactiveCampaigns(params)),
          withTimeout(DashboardHttp.getRecentActivity(params)),
          withTimeout(
            DashboardHttp.getFinishedCampaigns({
              ...params,
              sort_by: this.finishedSort.column,
              order: this.finishedSort.order,
            })
          ),
          withTimeout(DashboardHttp.getLatestUsers({ ...params, limit: 100 })),
          withTimeout(DashboardHttp.getInactiveUsers({ ...params, limit: 100 })),
          withTimeout(DashboardHttp.getPlaqueEligible()),
          withTimeout(this.loadTopUsersRevenue()),
        ]);

        const val = (i) =>
          results[i].status === "fulfilled" ? results[i].value?.data : null;

        this.topUsers = val(0)?.ranking || this.topUsers || [];
        this.topCampaigns = val(1)?.campaigns || this.topCampaigns || [];
        this.latestCampaigns = val(2)?.campaigns || this.latestCampaigns || [];
        this.inactiveCampaigns =
          val(3)?.campaigns || this.inactiveCampaigns || [];
        this.recentActivity = val(4)?.campaigns || this.recentActivity || [];
        this.finishedCampaigns =
          val(5)?.campaigns || this.finishedCampaigns || [];
        if (val(5)?.global_total_collected != null) {
          this.globalTotalCollected = val(5).global_total_collected;
        }
        this.latestUsers = val(6)?.users || this.latestUsers || [];
        this.inactiveUsersList = val(7)?.users || this.inactiveUsersList || [];
        this.plaqueEligible = val(8)?.users || this.plaqueEligible || [];

        // Carregar gráficos e inteligência de origens em paralelo
        await Promise.allSettled([
          withTimeout(this.loadCharts(params), 30000),
          withTimeout(this.loadSourcesAnalytics(params), 30000),
        ]);
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao carregar dados do dashboard",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    getSourceBadgeMeta(source) {
      const key = String(source || "").toLowerCase().trim();
      const meta = {
        google: { label: "Google", icon: "search", badgeClass: "source-badge-google" },
        instagram: { label: "Instagram", icon: "photo_camera", badgeClass: "source-badge-instagram" },
        youtube: { label: "YouTube", icon: "smart_display", badgeClass: "source-badge-youtube" },
        facebook: { label: "Facebook", icon: "public", badgeClass: "source-badge-facebook" },
        tiktok: { label: "TikTok", icon: "music_note", badgeClass: "source-badge-tiktok" },
        indicacao: { label: "Indicação", icon: "people", badgeClass: "source-badge-indicacao" },
        grupo: { label: "Grupo", icon: "groups", badgeClass: "source-badge-grupo" },
        anuncio: { label: "Anúncio", icon: "campaign", badgeClass: "source-badge-anuncio" },
        outro: { label: "Outro", icon: "more_horiz", badgeClass: "source-badge-outro" },
      };
      return meta[key] || {
        label: source ? String(source).toUpperCase() : "Outro",
        icon: "label",
        badgeClass: "source-badge-outro",
      };
    },
    async loadSourcesAnalytics(params) {
      if (this.isUnmounted) return;
      try {
        const res = await DashboardHttp.getSourcesAnalytics(params);
        if (this.isUnmounted) return;
        const data = res.data || {};
        this.sourcesAnalytics = {
          sources: data.sources || [],
          total_users: data.total_users || 0,
          total_revenue: data.total_revenue || 0,
          total_gmv: data.total_gmv || 0,
          chart_labels: data.chart_labels || [],
          chart_users: data.chart_users || [],
          chart_revenue: data.chart_revenue || [],
        };

        const channelColors = {
          google: "#4285F4",
          instagram: "#E1306C",
          youtube: "#FF0000",
          facebook: "#1877F2",
          tiktok: "#111827",
          indicacao: "#10b981",
          grupo: "#25D366",
          anuncio: "#f59e0b",
          outro: "#6c757d",
        };

        const bgColors = (data.sources || []).map(
          (s) => channelColors[s.source] || "#3a416f"
        );

        if (data.chart_users && data.chart_users.length > 0) {
          this.sourcesUsersChartData = {
            labels: data.chart_labels || [],
            datasets: [
              {
                data: data.chart_users || [],
                backgroundColor: bgColors,
                borderWidth: 0,
              },
            ],
          };
        } else {
          this.sourcesUsersChartData = null;
        }

        if (data.chart_revenue && data.chart_revenue.length > 0) {
          this.sourcesRevenueChartData = {
            labels: data.chart_labels || [],
            datasets: [
              {
                label: "Receita (R$)",
                data: data.chart_revenue || [],
                backgroundColor: bgColors,
                borderRadius: 6,
              },
            ],
          };
        } else {
          this.sourcesRevenueChartData = null;
        }
      } catch (err) {
        console.error("Erro ao carregar métricas de origens:", err);
      }
    },
    async loadCharts(params) {
      if (this.isUnmounted) return;
      try {
        const [revenueRes, usersRes, paymentRes, drawersRes, statusRes] =
          await Promise.all([
            DashboardHttp.getRevenueChart(params),
            DashboardHttp.getUsersChart(params),
            DashboardHttp.getPaymentMethodsChart(params),
            DashboardHttp.getCampaignDrawersChart(params),
            DashboardHttp.getCampaignStatusChart(params),
          ]);

        if (this.isUnmounted) return;

        this.revenueChartData = {
          labels: revenueRes.data.labels || [],
          datasets: [
            {
              label: "Ganhos (R$)",
              data: revenueRes.data.data || [],
              backgroundColor: "rgba(76, 175, 80, 0.2)",
              borderColor: "rgba(76, 175, 80, 1)",
              borderWidth: 2,
              fill: true,
              tension: 0.4,
            },
          ],
        };

        this.usersChartData = {
          labels: usersRes.data.labels || [],
          datasets: [
            {
              label: "Novos Usuários",
              data: usersRes.data.data || [],
              backgroundColor: "rgba(33, 150, 243, 0.2)",
              borderColor: "rgba(33, 150, 243, 1)",
              borderWidth: 2,
              fill: true,
              tension: 0.4,
            },
          ],
        };

        this.paymentMethodsChartData = {
          labels: paymentRes.data.labels || [],
          datasets: [
            {
              data: paymentRes.data.data || [],
              backgroundColor: [
                "#e91e63",
                "#3a416f",
                "#17ad37",
                "#fb8c00",
                "#cb0c9f",
              ],
              borderWidth: 0,
            },
          ],
        };

        this.campaignDrawersChartData = {
          labels: drawersRes.data.labels || [],
          datasets: [
            {
              label: "Quantidade",
              data: drawersRes.data.data || [],
              backgroundColor: "rgba(233, 30, 99, 0.8)",
              borderRadius: 5,
            },
          ],
        };

        this.campaignStatusChartData = {
          labels: statusRes.data.labels || [],
          datasets: [
            {
              data: statusRes.data.data || [],
              backgroundColor: ["#17ad37", "#f53939", "#fb8c00", "#3a416f"],
              borderWidth: 0,
            },
          ],
        };
      } catch (error) {
        console.error("Erro ao carregar gráficos:", error);
      }
    },
    editPlanMonthlyPrice() {
      const current = this.planMonthlyPrice || 97;
      const input = window.prompt(
        "Valor mensal unitário do plano Starter (R$) — usado só no cálculo local de MRR:",
        String(current)
      );
      if (input == null) return;
      const parsed = Number(String(input).replace(",", "."));
      if (!Number.isFinite(parsed) || parsed < 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Valor inválido",
          detail: "Informe um número válido.",
          life: 2500,
        });
        return;
      }
      this.planMonthlyPrice = parsed;
      localStorage.setItem("rifa365_plan_monthly_price", String(parsed));
    },
    async exportInactiveOwnersCsv() {
      try {
        this.exportingInactiveOwners = true;
        const res = await DashboardHttp.getInactiveCampaignOwners();
        const owners = res.data.owners || [];
        if (!owners.length) {
          this.$toast.add({
            severity: "warn",
            summary: "Sem contatos",
            detail: "Nenhum dono de campanha inativa encontrado.",
            life: 4000,
          });
          return;
        }

        const escapeCsv = (v) => {
          const s = String(v ?? "");
          if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
          return s;
        };

        const header = [
          "id",
          "nome",
          "email",
          "telefone",
          "campanhas_inativas",
          "ultima_campanha",
          "dias_sem_campanha",
        ];
        const lines = [header.join(";")];
        owners.forEach((o) => {
          lines.push(
            [
              o.id,
              escapeCsv(o.full_name),
              escapeCsv(o.email),
              escapeCsv(o.phone),
              o.inactive_campaigns,
              escapeCsv(o.last_campaign_at),
              o.days_since_last_campaign,
            ].join(";")
          );
        });

        const blob = new Blob(["\uFEFF" + lines.join("\n")], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `contatos-campanhas-inativas-${this.formatLocalYYYYMMDD(
          new Date()
        )}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$toast.add({
          severity: "success",
          summary: "CSV gerado",
          detail: `${owners.length} contatos únicos exportados.`,
          life: 4000,
        });
      } catch (error) {
        console.error("Erro ao exportar contatos inativos:", error);
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível exportar os contatos.",
          life: 4000,
        });
      } finally {
        this.exportingInactiveOwners = false;
      }
    },
    formatCurrency(value) {
      if (value == null || value === "") return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(value) || 0);
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("pt-BR");
    },
    getInitials(name) {
      if (!name) return "U";
      return name
        .split(" ")
        .map((n) => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();
    },
    calculatePercentage(count) {
      if (!this.topUsers || this.topUsers.length === 0) return 0;
      const maxCount = this.topUsers[0].campaigns_count;
      if (maxCount === 0) return 0;
      return Math.round((count * 100) / maxCount);
    },
    getSalesProgress(camp) {
      if (!camp.qnt_quotas) return 0;
      return Math.round(
        ((camp.qnt_quotas - camp.remaining_quotas) * 100) / camp.qnt_quotas
      );
    },
    getCampaignImage(camp) {
      if (camp.images) {
        try {
          // No backend o campo é json.RawMessage, que chega como string JSON ou array
          const images =
            typeof camp.images === "string"
              ? JSON.parse(camp.images)
              : camp.images;
          if (Array.isArray(images) && images.length > 0) {
            return images[0];
          }
        } catch (e) {
          console.error("Erro ao processar imagens", e);
        }
      }
      return require("@/assets/img/NoImgAdded.png");
    },
    openRaffle(slug) {
      window.open(buildCampaignPublicUrl(slug, this.user), "_blank");
    },
    toggleExpand(id) {
      if (this.expandedCampaigns.includes(id)) {
        this.expandedCampaigns = this.expandedCampaigns.filter((i) => i !== id);
      } else {
        this.expandedCampaigns.push(id);
      }
    },
    loadMoreInactive() {
      this.inactiveLimit += 20;
    },
  },
};
</script>

<style scoped lang="scss">
.chart {
  position: relative;
  height: 300px;
}

.hover-shadow {
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-5px);
  }
}

.transition-all {
  transition: all 0.3s ease;
}

.ranking-row {
  transition: background-color 0.2s ease;
  &:hover {
    background-color: rgba(228, 27, 128, 0.05);
  }
}

.medal {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.medal-gold {
  border: 2px solid #ffd700;
  background: linear-gradient(135deg, #fff 0%, #fff9e6 100%);
}
.medal-silver {
  border: 2px solid #c0c0c0;
  background: linear-gradient(135deg, #fff 0%, #f2f2f2 100%);
}
.medal-bronze {
  border: 2px solid #cd7f32;
  background: linear-gradient(135deg, #fff 0%, #f9f2ec 100%);
}

.grey-rank {
  color: #adb5bd;
  width: 40px;
  text-align: center;
  display: inline-block;
}

.border-light-gray {
  border: 1px solid #f0f2f5 !important;
}

.campaign-card-img {
  transition: transform 0.5s ease;
}

.card:hover .campaign-card-img {
  transform: scale(1.1);
}

.bg-gray-50 {
  background-color: #fafafa;
}
.bg-gray-100 {
  background-color: #f8f9fa;
}

.btn-icon-only.btn-sm {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.source-main-icon-bubble {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  color: #38bdf8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
}

.source-kpi-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.06);
  }
}

.source-pill-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1;

  &--sm {
    padding: 2px 6px;
    font-size: 0.65rem;
  }

  &--xs {
    padding: 1px 4px;
    font-size: 0.58rem;
  }
}

.source-badge-google {
  background: rgba(66, 133, 244, 0.12);
  color: #1a73e8;
  border: 1px solid rgba(66, 133, 244, 0.25);
}
.source-badge-instagram {
  background: rgba(225, 48, 108, 0.12);
  color: #c13584;
  border: 1px solid rgba(225, 48, 108, 0.25);
}
.source-badge-youtube {
  background: rgba(255, 0, 0, 0.1);
  color: #cc0000;
  border: 1px solid rgba(255, 0, 0, 0.2);
}
.source-badge-facebook {
  background: rgba(24, 119, 242, 0.12);
  color: #1877f2;
  border: 1px solid rgba(24, 119, 242, 0.25);
}
.source-badge-tiktok {
  background: rgba(0, 0, 0, 0.08);
  color: #111;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.source-badge-indicacao {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
  border: 1px solid rgba(16, 185, 129, 0.25);
}
.source-badge-grupo {
  background: rgba(37, 211, 102, 0.12);
  color: #128c7e;
  border: 1px solid rgba(37, 211, 102, 0.25);
}
.source-badge-anuncio {
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
  border: 1px solid rgba(245, 158, 11, 0.25);
}
.source-badge-outro {
  background: rgba(108, 117, 125, 0.1);
  color: #495057;
  border: 1px solid rgba(108, 117, 125, 0.2);
}
</style>
